import {createApp} from 'vue'
//import './style.pcss'
import App from './App.vue'
import Catalog from './views/Catalog.vue'
import AddToOffer from './views/AddToOffer.vue'
import ProductGallery from './components/Gallery.vue'
import {createRouter, createWebHistory} from 'vue-router'
import useHeroSlider from './components/HeroSlider'

const About = {template: '<div>About</div>'}
const routes = [
  {path: '/', component: Catalog},
  {path: '/default/products/catalog', component: Catalog},
]

const router = createRouter({
  history: createWebHistory(),
  routes,
});
//const app = createApp(App)
//app.use(router);


window.addEventListener("DOMContentLoaded", async (event) => {
  //app.mount('#catalog')

  const AddToOfferContainer = document.querySelector('.add-to-offer');
  if (AddToOfferContainer) {
    const AddToOfferApp = createApp(AddToOffer, {
      productId: AddToOfferContainer.dataset.productId,
      translates: JSON.parse(AddToOfferContainer.dataset.translates)
    })

    AddToOfferApp.mount(AddToOfferContainer)
  }

  const productGalleryContainer = document.querySelector('.co-product-images-vue');
  if (productGalleryContainer) {
    const images = JSON.parse(productGalleryContainer.dataset.images)
    createApp(ProductGallery, {
      images
    }).mount(productGalleryContainer)
  }

  const offerContainer = document.querySelector('.offer-container');
  if (offerContainer) {
    const { default: Offer } = await import('./components/Offer.vue');
    const LANG = offerContainer.dataset.lang;
    createApp(Offer, offerContainer.dataset).mount(offerContainer);
  }

  useHeroSlider();
})
